type RetrieveEventError = {
  notFound: boolean;
};

const retrieveEventError: RetrieveEventError = {
  notFound: false,
};

export type { RetrieveEventError };

export { retrieveEventError };
